import CreateBloomsTaxonomyActivityView from "@features/tools/view/blooms-taxonomy-activity-view/create-blooms-taxonomy-activity-view";

const CreateBloomsTaxonomyActivity = () => {
  return <CreateBloomsTaxonomyActivityView />;
};

export default CreateBloomsTaxonomyActivity;
